import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { route } from "./static/route";
import FeedbackCaptureLayer from "./components/devFeedback/FeedbackCaptureLayer";
import FeedbackOverlayLayer from "./components/devFeedback/FeedbackOverlayLayer";
import LoginPage from "./pages/login";
import NotFoundPage from "./pages/notFound";
import DashboardPage from "./pages/dashboard";
import PrivateRoute from "./components/route/PrivateRoute";
import ItemsPage from "./pages/items";
import ProcessesPage from "./pages/processes";
import ProcessDefinitionsPage from "./pages/processDefinitions";
import ProcessDefinitionRatesPage from "./pages/processDefinitions/rates";
import PartiesPage from "./pages/parties";
import PartyViewPage from "./pages/parties/view";
import PartyRatesPage from "./pages/parties/rates";
import PaymentsPage from "./pages/payments";
import UsersPage from "./pages/users";
import UsersCreatePage from "./pages/users/create";
import UsersEditPage from "./pages/users/edit";
import AccountTypesPage from "./pages/accountTypes";
import AccountsPage from "./pages/accounts";
import MaterialsPage from "./pages/materials";
import ItemSizesPage from "./pages/itemSizes";
import ProfilePage from "./pages/profile";
import SettingsPage from "./pages/settings";
import ProcessOrdersPage from "./pages/processOrders";
import ProcessOrderCreatePage from "./pages/processOrders/create";
import ProcessOrderEditPage from "./pages/processOrders/edit";
import ProcessOrderViewPage from "./pages/processOrders/view";
import ProcessReceivesPage from "./pages/processReceives";
import ProcessReceiveCreatePage from "./pages/processReceives/create";
import ProcessReceiveEditPage from "./pages/processReceives/edit";
import ProcessReceiveViewPage from "./pages/processReceives/view";
import ActivityLogsPage from "./pages/activityLogs";
import DevFeedbackPage from "./pages/devFeedback";
import StockSizesPage from "./pages/stock/sizes";
import StockPiecesPage from "./pages/stock/pieces";
import StockProcessItemsPage from "./pages/stock/processItems";
import StockProcessPartiesPage from "./pages/stock/processParties";

const FEEDBACK_WIDGET_ENABLED = process.env.REACT_APP_FEEDBACK_WIDGET_ENABLED === "true";

const App = () => {
  return (
    <AuthProvider>
      {FEEDBACK_WIDGET_ENABLED && <FeedbackCaptureLayer />}
      {FEEDBACK_WIDGET_ENABLED && <FeedbackOverlayLayer />}
      <Routes>
        <Route path={route.login} element={<LoginPage />} />

        <Route
          path={route.dashboard}
          element={
            <PrivateRoute element={<DashboardPage />} path={route.login} />
          }
        />

        <Route
          path={route.items}
          element={<PrivateRoute element={<ItemsPage />} path={route.login} permission="items.menu" />}
        />

        <Route
          path={route.processes}
          element={
            <PrivateRoute element={<ProcessesPage />} path={route.login} permission="processes.menu" />
          }
        />
        <Route
          path={route.processDefinitions}
          element={
            <PrivateRoute element={<ProcessDefinitionsPage />} path={route.login} permission="process-definitions.menu" />
          }
        />
        <Route
          path={route.processDefinitionRates}
          element={
            <PrivateRoute element={<ProcessDefinitionRatesPage />} path={route.login} permission="parties.rate" />
          }
        />

        <Route
          path={route.parties}
          element={
            <PrivateRoute element={<PartiesPage />} path={route.login} permission="parties.menu" />
          }
        />
        <Route
          path={route.partiesView}
          element={
            <PrivateRoute element={<PartyViewPage />} path={route.login} permission="parties.menu" />
          }
        />
        <Route
          path={route.partiesRates}
          element={
            <PrivateRoute element={<PartyRatesPage />} path={route.login} permission="parties.rate" />
          }
        />

        <Route
          path={route.payments}
          element={
            <PrivateRoute element={<PaymentsPage />} path={route.login} permission="parties.payment" />
          }
        />

        <Route
          path={route.users}
          element={<PrivateRoute element={<UsersPage />} path={route.login} permission="users.menu" />}
        />

        <Route
          path={route.usersCreate}
          element={
            <PrivateRoute element={<UsersCreatePage />} path={route.login} permission="users.create" />
          }
        />

        <Route
          path={route.usersEdit}
          element={
            <PrivateRoute element={<UsersEditPage />} path={route.login} permission="users.update" />
          }
        />

        <Route
          path={route.accountTypes}
          element={
            <PrivateRoute element={<AccountTypesPage />} path={route.login} permission="account-types.menu" />
          }
        />

        <Route
          path={route.accounts}
          element={
            <PrivateRoute element={<AccountsPage />} path={route.login} permission="accounts.menu" />
          }
        />

        <Route
          path={route.materials}
          element={<PrivateRoute element={<MaterialsPage />} path={route.login} permission="materials.menu" />}
        />

        <Route
          path={route.itemSizes}
          element={<PrivateRoute element={<ItemSizesPage />} path={route.login} permission="item-sizes.menu" />}
        />

        <Route
          path={route.processOrders}
          element={<PrivateRoute element={<ProcessOrdersPage />} path={route.login} permission="process-orders.menu" />}
        />
        <Route
          path={route.processOrdersCreate}
          element={<PrivateRoute element={<ProcessOrderCreatePage />} path={route.login} permission="process-orders.create" />}
        />
        <Route
          path={route.processOrdersEdit}
          element={<PrivateRoute element={<ProcessOrderEditPage />} path={route.login} permission="process-orders.update" />}
        />
        <Route
          path={route.processOrdersView}
          element={<PrivateRoute element={<ProcessOrderViewPage />} path={route.login} permission="process-orders.read" />}
        />
        <Route
          path={route.processReceives}
          element={<PrivateRoute element={<ProcessReceivesPage />} path={route.login} permission="process-receives.menu" />}
        />
        <Route
          path={route.processReceivesCreate}
          element={<PrivateRoute element={<ProcessReceiveCreatePage />} path={route.login} permission="process-receives.create" />}
        />
        <Route
          path={route.processReceivesEdit}
          element={<PrivateRoute element={<ProcessReceiveEditPage />} path={route.login} permission="process-receives.update" />}
        />
        <Route
          path={route.processReceivesView}
          element={<PrivateRoute element={<ProcessReceiveViewPage />} path={route.login} permission="process-receives.read" />}
        />

        <Route
          path={route.stockSizes}
          element={<PrivateRoute element={<StockSizesPage />} path={route.login} permission="sizes-stock" />}
        />
        <Route
          path={route.stockPieces}
          element={<PrivateRoute element={<StockPiecesPage />} path={route.login} permission="pieces-stock" />}
        />
        <Route
          path={route.stockProcessItems}
          element={<PrivateRoute element={<StockProcessItemsPage />} path={route.login} permission="process-items-stock" />}
        />
        <Route
          path={route.stockProcessParties}
          element={<PrivateRoute element={<StockProcessPartiesPage />} path={route.login} permission="process-party-stock" />}
        />

        <Route
          path={route.activityLogs}
          element={
            <PrivateRoute element={<ActivityLogsPage />} path={route.login} permission="activity-logs" />
          }
        />

        {FEEDBACK_WIDGET_ENABLED && (
          <Route
            path={route.devFeedback}
            element={
              <PrivateRoute element={<DevFeedbackPage />} path={route.login} permission="dev-feedback" />
            }
          />
        )}

        <Route
          path={route.profile}
          element={
            <PrivateRoute element={<ProfilePage />} path={route.login} />
          }
        />

        <Route
          path={route.settings}
          element={
            <PrivateRoute element={<SettingsPage />} path={route.login} permission="settings" />
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  );
};
export default App;
